module.exports = __webpack_public_path__ + "static/media/logo_black.dce07b8a.png";